import * as React from 'react'
import { FieldProps } from 'formik'
import { RoundedRadioWrapper, RoundedRadio } from '$views/components/RoundedRadio'
import { Text } from '$views/components/Text'
import { Block } from '$views/components/Layout/Block'
import { Division } from '$views/components/Division'
import { ErrorText } from '$views/components/Input/Input'

interface Props {
  label: string
  type: string
  onBlur?: () => {}
  hasError: boolean
  child?: boolean
}
interface State {
  isChecked: boolean
}

export class GenderField extends React.Component<Props & FieldProps<any>, State> {
  state = { isChecked: false }

  isChecked = (fieldName: string) => {
    const { values } = this.props.form
    return values[this.props.field.name] === fieldName
  }

  getFemaleLabel = child => {
    if (child) {
      return 'Niña'
    }
    return 'Mujer'
  }

  getMaleLabel = child => {
    if (child) {
      return 'Niño'
    }
    return 'Hombre'
  }

  render() {
    const { label, field, onBlur, form, hasError, child } = this.props
    const hasGenderErrors = form.submitCount > 0 && form.errors.gender && !hasError
    return (
      <fieldset>
        <Text marginTop="base" marginBottom="mini" weight="medium">
          {label}
        </Text>
        <Block marginBottom="mini">
          <RoundedRadioWrapper {...field}>
            <RoundedRadio
              name={field.name}
              value={'2'}
              label={this.getFemaleLabel(child)}
              isChecked={this.isChecked}
              onBlur={onBlur}
            />
            <RoundedRadio
              name={field.name}
              value={'1'}
              label={this.getMaleLabel(child)}
              isChecked={this.isChecked}
              onBlur={onBlur}
            />
          </RoundedRadioWrapper>
        </Block>
        {hasGenderErrors && (
          <ErrorText as="p" caption error>
            {form.errors.gender}
          </ErrorText>
        )}
        {!hasError && (
          <Division color={hasGenderErrors ? 'darkPink' : 'lightGrey'} marginTop={hasGenderErrors ? 'tiny' : 'small'} />
        )}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Profile/Caretaker/PersonalData/ContactInfo/components/GenderField.tsx